export default {
  mini: state => state.mini,
  allMenuItems: state => ({
    ...state.navigationRules,
    ...state.customMenuItems
  }),
  activeMenuItems: (state, getters) => {
    const filtered = {};
    Object.entries(getters.allMenuItems).forEach(([key, item]) => {
      if (!state.disabledMenuItems.includes(key)) {
        filtered[key] = item;
      }
    });
    return filtered;
  }
}
